// export const SHOW_ORDER_DETAILS = 'SHOW_ORDER_DETAILS';
// export const TOGGLE_MODAL = "TOGGLE_MODAL";

export const SHOW_ORDER_DETAILS = 'SHOW_ORDER_DETAILS';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const TOGGLE_ADD_ORDER_MODAL = 'TOGGLE_ADD_ORDER_MODAL';
